module.exports = __webpack_public_path__ + "static/media/sun-bg.6817b6de.svg";